import { HierarchicalLabelOrFolder } from '../store/Inbox/Labels/types';

export const getItemId = (item: HierarchicalLabelOrFolder): string => {
  return 'labelId' in item ? item.labelId : item.id;
};
